

















import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import ToastItem from "@/components/ToastItem.vue";
import {
  ToastContent,
  ToastContents,
  ShowMutation,
  HideMutation
} from "@/store/toasts";

const { State, Mutation } = namespace("toasts");

@Component({
  components: {
    ToastItem
  }
})
export default class ToastArea extends Vue {
  @State toasts!: ToastContents;
  @Mutation show!: (payload: ShowMutation) => void;
  @Mutation hide!: (payload: HideMutation) => void;

  get sortedToasts() {
    function date(value: { content: ToastContent }) {
      return value.content.date.valueOf();
    }

    return Object.entries(this.toasts)
      .map(([id, value]) => ({ id, ...value }))
      .sort((first, second) => date(second) - date(first));
  }

  shown(id: string, content: ToastContent) {
    if (this.toasts[id].show) {
      return;
    }

    this.show({ id, content });
  }

  hidden(id: string) {
    this.hide({ id });
  }
}
